import { render, staticRenderFns } from "./display-text.vue?vue&type=template&id=040de793&scoped=true&"
import script from "./display-text.vue?vue&type=script&lang=js&"
export * from "./display-text.vue?vue&type=script&lang=js&"
import style0 from "./display-text.vue?vue&type=style&index=0&id=040de793&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040de793",
  null
  
)

export default component.exports